var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upload_wrapper", attrs: { id: "upload_wrapper" } },
    [
      _c(
        "el-upload",
        {
          ref: "pictureUpload",
          class: { disabled: _vm.uploadDisabled || _vm.disabled },
          attrs: {
            action: _vm.api,
            "list-type": "picture-card",
            "before-upload": _vm.beforeUpload,
            "on-success": _vm.uploadSuccess,
            "on-error": _vm.uploadError,
            multiple: _vm.multiple,
            limit: _vm.limit,
            "on-change": _vm.handleChange,
            "file-list": _vm.showfileList,
            "on-progress": _vm.uploadVideoProcess,
            "on-exceed": _vm.handleOverLimit,
          },
          scopedSlots: _vm._u([
            {
              key: "file",
              fn: function (ref) {
                var file = ref.file
                return _c(
                  "div",
                  { staticStyle: { width: "100%", height: "100%" } },
                  [
                    file.videoFlag == true
                      ? _c("el-progress", {
                          attrs: {
                            type: "circle",
                            percentage: _vm.videoUploadPercent,
                          },
                        })
                      : _c(
                          "el-image",
                          {
                            staticClass: "el-upload-list__item-thumbnail",
                            attrs: { src: file.url, fit: "cover" },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "justify-content": "center",
                                  "align-items": "center",
                                  width: "100%",
                                  height: "100%",
                                  color: "#909399",
                                  "font-size": "20px",
                                  background: "#f5f7fa",
                                },
                                attrs: { slot: "error" },
                                slot: "error",
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline",
                                }),
                              ]
                            ),
                          ]
                        ),
                    _vm._v(" "),
                    file.videoFlag == false
                      ? _c(
                          "span",
                          { staticClass: "el-upload-list__item-actions" },
                          [
                            file.name
                              ? _c(
                                  "el-tooltip",
                                  {
                                    staticClass: "item",
                                    attrs: {
                                      effect: "dark",
                                      content: file.name,
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-preview",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handlePictureCardPreview(
                                                file
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-zoom-in",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "el-upload-list__item-delete",
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDownload(file)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-download",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !_vm.disabled
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-upload-list__item-delete",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleRemove(file)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            [
                              _c("div", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-preview",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePictureCardPreview(
                                          file
                                        )
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-zoom-in" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "el-upload-list__item-delete",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDownload(file)
                                      },
                                    },
                                  },
                                  [_c("i", { staticClass: "el-icon-download" })]
                                ),
                                _vm._v(" "),
                                !_vm.disabled
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "el-upload-list__item-delete",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(file)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                            ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                )
              },
            },
          ]),
        },
        [
          _c("i", {
            staticClass: "el-icon-plus",
            attrs: { slot: "default" },
            slot: "default",
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            "append-to-body": "",
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.pdfFlag
            ? _c("embed", {
                staticStyle: { width: "100%", height: "800px" },
                attrs: { src: _vm.dialogImageUrl },
              })
            : _c("img", {
                attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
              }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }